export default __webpack_public_path__ + "static/media/401-1.d5884051.jpg";